<template>
    <div>
        <div class="tile-content">
            <div class="grid-fitted grid-unstackable align-items-center stack-s">
                <div class="grid-item inline-m">
                    <h3><span class="inline-s">{{ website.name }}</span>
                    </h3>
                </div>
                <div class="grid-item no-flex" v-if="$auth.$pages['update-website'].isAllowed">
                    <v-popper class="no-flex" position="bottomEnd" :offset="8">
                        <div slot="trigger">
                            <v-icon-button class="no-padding" size="small" type="basic" v-popper-trigger>
                                <v-icon icon="actions"/>
                            </v-icon-button>
                        </div>
                        <div class="popover" slot="content">
                            <div class="popover-control">
                                <div class="popover-content popover-menu">
                                    <a class="popover-menu-item" @click="$emit('open-update-modal', website)">Edit Website</a>
                                    <a class="popover-menu-item popover-menu-item-negative" @click="$emit('open-delete-modal', website)">Delete
                                        Website</a>
                                </div>
                            </div>
                        </div>
                    </v-popper>
                </div>
            </div>
            <table class="table table-definition table-compact table-collapsed table-v-alignment-top">
                <colgroup>
                    <col style="width:108px;">
                    <col>
                </colgroup>
                <tr>
                    <td>ID</td>
                    <td v-fs-block>{{ website.id | truncate({limit: 36, dots: true}) }}</td>
                </tr>
                <tr>
                    <td>URL</td>
                    <td v-fs-block><a target="_blank" :href="website.url">{{ website.url }}</a></td>
                </tr>
                <tr>
                    <td>Service Email</td>
                    <td v-fs-block>{{ website.serviceEmail }}</td>
                </tr>
                <tr>
                    <td>Service Phone</td>
                    <td v-fs-block>{{ website.servicePhone }}</td>
                </tr>
                <template v-if="website.hasCustomFields">
                    <tr
                        v-for="field in customFields"
                        :key="field.name">
                        <td>{{field.name}}</td>
                        <td v-fs-block>{{field.value}}</td>
                    </tr>
                </template>
            </table>
        </div>
        <div></div>
    </div>
</template>

<script>
    import {
        vIconButton,
        vIcon,
    } from '@/components/form';
    import vPopper from '@/components/v-popper';
    import WebsiteModel from '@/common/models/website-model';
    import CustomFieldsValuesMixin from '@/mixins/custom-fields-values-mixin';

    export default {
        name: 'website-item',
        mixins: [
            CustomFieldsValuesMixin,
        ],
        components: {
            vIconButton,
            vIcon,
            vPopper,
        },
        props: {
            website: {
                type: WebsiteModel,
            },
            websitesCustomFields: Array,
        },
        computed: {
            customFields() {
                return this.getCustomFields('website', this.getCustomFieldsTypes(this.websitesCustomFields));
            },
        },
    };
</script>
